<template>
  <div>
    <div class="tw-flex tw-justify-center tw-justify-items-center tw-my-8">
      <back-nav to="BranchSelectionReview" />
    </div>
    <v-card class="tw-pb-12 tw-px-4">
      <card-title>Overview</card-title>
      <top-stepper current="BranchSelections" :cover-type="coverType" />
      <div class="tw-px-0 md:tw-px-10 xl:tw-px-16 ">
        <div>
          <div>
            <div class='policydetails'>
            <h3
              class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10"
            >
              Policy Summary
            </h3>
            <hr class="tw-mt-3 tw-mb-10" />
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
              <div class="tw-w-full tw-bg-blue-100 tw-shadow-md tw-p-4">
                <p class="c-blue-text title-font font-weight-bold my-5">
                  Policy Renewal
                </p>
                <div v-if="coverType.coverTypeId === 121">
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    Third Party Only cover
                  </p>
                </div>
                <div v-else-if="coverType.coverTypeId === 120">
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    Comprehensive car insurance cover
                  </p>
                </div>
                <div v-else>
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    Bima Bamba insurance cover
                  </p>
                </div>
                <div class="tw-grid tw-grid-cols-2">
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    Policy Number
                  </p>
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    {{ this.$route.params.policyNo }}
                  </p>
                </div>
                <div class="tw-grid tw-grid-cols-2">
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    Cover start date
                  </p>
                  <p class="c-blue-text title-font font-weight-bold my-5">
                    {{ displayRenewalStartDate }}
                  </p>
                </div>
              </div>
              <div
                class="tw-w-full tw-bg-blue-100 tw-shadow-md tw-py-5 px-10 tw-grid tw-grid-cols-2"
              >
                <p class="c-blue-text title-font font-weight-bold my-5">
                  Basic Premium
                </p>
                <p
                  class="c-blue-text tw-text-right title-font font-weight-bold my-5"
                >
                  Ksh. {{ renewal.premium | formatNum }}
                </p>
                <p class="c-blue-text title-font font-weight-bold my-5">
                  Add Ons
                </p>
                <p
                  class="c-blue-text tw-text-right title-font font-weight-bold my-5"
                >
                  Ksh. {{ renewal.addOns | formatNum }}
                </p>
                <p class="c-blue-text title-font font-weight-bold my-5">
                  ITL & PHCF
                </p>
                <p
                  class="c-blue-text tw-text-right title-font font-weight-bold my-5"
                >
                  Ksh. {{ renewal.taxes | formatNum }}
                </p>
                <p class="c-blue-text title-font font-weight-bold my-5">
                  Stamp Duty
                </p>
                <p
                  class="c-blue-text tw-text-right title-font font-weight-bold my-5"
                >
                  Ksh. {{ renewal.stampDuty | formatNum }}
                </p>
                <p class="c-blue-text title-font font-weight-bold my-5">
                  Total Premium
                </p>
                <p
                    class="c-blue-text tw-text-right title-font font-weight-bold my-5"                >
                  Ksh. {{ renewal.premiumAfterTax | formatNum }}
                </p>
                <hr class="tw-col-span-2" />
                <p class="c-blue-text c-title font-weight-bold my-5">
                  Premium To Pay
                </p>
                <p
                  v-if="coverType.coverTypeId === 120"
                  class="c-gray-text tw-text-right title-font tw-font-bold my-5 tw-underline tw-text-3xl tw-justify-items-start"
                >
                  Ksh. {{ renewal.premiumInstalments[0].premium | formatNum }}
                </p>
                <p
                  v-else
                  class="c-gray-text tw-text-right title-font tw-font-bold my-5 tw-underline tw-text-3xl tw-justify-items-start"
                >
                  Ksh. {{ renewal.premiumAfterTax | formatNum }}
                </p>
              </div>
            </div>
          </div>
          <v-card-actions>
  <div class="tw-w-full tw-mt-10 tw-text-md">
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
      <v-btn
        class="tw-rounded-none tw-normal-case tw-text-2xl tw-px-5 tw-w-64 tw-h-16 tw-flex tw-items-center tw-justify-center"
        @click="proceed"
        color="primary"
      >
        Pay Now
      </v-btn>
    </div>
  </div>
</v-card-actions>

          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';
import validations from '@/utils/validations';
import helpers from '@/utils/helpers';
import BackNav from '@/components/buy/BackNav';
import { FB_RENEW_POLICY_REVIEW } from '@/utils/const';
import { mapGetters } from 'vuex';
import TopStepper from '@/components/buy/TopStepper';
import renewalMixin from '@/mixins/renewalMixin';
import helperMixins from '@/mixins/helperMixins';

export default {
  name: 'PolicyReview',
  props: {
    renewal: {
      type: Object,
      required: true,
    },
  },
  components: {
    TopStepper,
    BackNav,
    CardTitle,
  },
  data() {
    return {
      ...validations,
    };
  },
  computed: {
    ...mapGetters('variables', ['getMotorBaseUrl']),
    ...mapGetters('variables', ['getMotorBaseUrl']),
    displayRenewalStartDate() {
      const renew = localStorage.getItem('renewalData');
      const today = new Date();
      const endDate = new Date(renew.endDate);
      return today <= endDate ? renew.endDate : today.toISOString().split('T')[0];
    },
  },
  metaInfo: {
    title: 'Renew - Review Policy',
  },
  mixins: [renewalMixin, helperMixins],
  methods: {
    proceed() {
      this.$analytics.logEvent(FB_RENEW_POLICY_REVIEW, {
        product: 'Renewal Journey Policy Review',
      });
      const renewalData = this.getLocalStorageJson('renewalData');
      const personalData = this.getLocalStorageJson('personalData');

      let percentage = this.distribution === '100' ? 100 : 40;
      if (this.coverType.coverTypeId === 121) {
        percentage = 100;
      }
      const payment = {
        payableAmount:
          this.coverType.coverTypeId === 120
            ? this.renewal.premiumInstalments[0].premium
            : this.renewal.premiumAfterTax,
        kraPin: personalData.kraPinNumber,
        accountReference: renewalData.vehicle.regNo,
        description:
          this.batchId !== null
            ? `ren-${this.batchId}`
            : `rfq-${this.getQuote.quoteId}`,
        customerPhoneNumber: personalData.mobileNo,
        serviceType: 'MOTOR',
        transactionType: 'PAYMENT',
      };
      const quoteInfo = {
        coverType: this.coverType,
        payPercentage: percentage,
        client: personalData,
        pageTitle: this.pageTitle,
        freeBenefits: renewalData.freeBenefits,
      };
      this.$emit('to-make-payment', {
        ...this.renewal,
        data: { payment, quoteInfo },
      });
    },

  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
